$(document).ready(function() {

    const forms = document.querySelectorAll('.mailchimp-signup');

    forms.forEach(form => {

        // on form submission, disable the submit button to prevent double submission
        form.addEventListener('submit', function (e) {
            const submitButton = form.querySelector('button[type=submit], input[type=submit]');
            
            if (submitButton) {
                submitButton.disabled = true;
                submitButton.value = 'Submitting...'; // Optional: update button text
            }
        });
    });

});